import styled, { keyframes, css } from "styled-components";

const fadeSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledAICampaign = styled.div`
  display: flex;
  justify-content: center;

  .content-holder {
    width: 100%;
    max-width: 850px;

    ${({ $disableForm }) =>
    $disableForm &&
    `
      user-select: none;
      cursor: not-allowed;
      
      .fields-wrapper {
        pointer-events: none;
        opacity: 0.6;
      }
    `}

    .title,
    .description {
      text-align: center;
    }
    .description {
      margin: 0 0 30px;
    }

    .input-box {
      padding: 30px 25px;
      border: 1px solid var(--gray-350);
      border-radius: 20px;
      margin: 0 0 25px;
    }
    .input-flex {
      display: flex;
      align-items: center;
      gap: 20px;
      &.margin-bottom {
        margin: 0 0 10px;
      }
    }

    .section-heading {
      display: block;
      font-size: 18px;
      line-height: 22px;
      color: var(--text-color-50);
      margin: 0 0 10px;

      .sub-heading {
        font-size: 14px;
        line-height: 18px;
        color: var(--light-50);
        margin: 0 0 10px;
      }
    }

    .btn-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;

      .delete-btn {
        border-color: var(--danger);
        color: var(--danger);
        padding: 8px 10px;
      }
      .edit-btn {
        padding: 8px 10px;
      }

      &.center-align {
        gap: 20px;
        justify-content: center;
      }
      .message-preview-btn {
        text-decoration: underline;
      }
    }

    .greeting-add-btn,
    .add-coaching-point-btn {
      margin: 0 0 25px;
    }

    .icon-holder {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 5px;

      &.delete {
        background: #f9e6e6;
      }

      &.edit {
        background: #eaf2ff;
      }
    }

    input,
    textarea {
      &::placeholder {
        color: var(--light-50);
      }
    }

    textarea {
      resize: none;
      min-height: 100px;
    }

    .auto-fill-btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      color: var(--white);
      background: linear-gradient(
        90deg,
        #367eee 0%,
        #b74bff 50.96%,
        #feb508 100%
      );
      padding: 10px 20px;
      border-radius: 60px;
      margin: 0 0 25px;
    }

    .tabs-btns {
      display: flex;
      gap: 10px;

      .tabBtn {
        width: 50%;
        padding: 1px;
        border-radius: 20px;
        border: 1px solid #efefef;
        background: #fdfdfd;

        .btn-content {
          position: relative;
          display: flex;
          gap: 15px;
          padding: 20px 16px;
          border-radius: 20px;
          text-align: left;
        }

        &.active {
          border: 1px solid rgba(49, 123, 255, 0.1);
          background: rgba(49, 123, 255, 0.1);

          .ico-tick {
            border: 1.5px solid var(--blue);

            &::before {
              display: block;
            }
          }

          .text-box {
            .heading,
            .subtitle {
              color: var(--blue);
            }
          }
        }
      }

      .ico-tick {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 50px;
        border: 1.5px solid #cacaca;
        position: relative;

        &::before {
          display: none;
          content: "";
          width: 12px;
          height: 12px;
          border-radius: 50px;
          background: var(--blue);
        }
      }

      .icon-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        border: 1px solid #efefef;
        background: var(--white);
      }

      .text-box {
        flex-grow: 1;

        .heading {
          display: block;
          font-size: 22px;
          line-height: 26px;
          font-weight: 600;
          margin: 0 0 6px;
        }

        .subtitle {
          display: block;
          font-size: 16px;
          line-height: 20px;
          color: var(--light-50);
        }
      }
    }

    .personalization-row {
      display: flex;
      align-items: center;
      gap: 30px;
      padding: 15px 20px;
      border-radius: 10px;

      &:last-child {
        margin: 0;
      }
    }

    .icon-box {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      background: #eaf3fe;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .text-box {
      flex-grow: 1;
      .heading {
        display: block;
        font-size: 18px;
        line-height: 22px;
        font-weight: 600;
        color: var(--text-color-50);
        margin: 0 0 6px;
      }

      .subtitle {
        display: block;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  .call-to-action-row,.greetings-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0 0 15px;

    > div {
      width: 100%;
    }

    .tox-editor-header {
      position: absolute;
      right: 0;
      left: auto;
    }

    .tox-tinymce {
      width: 100%;
      height: 50px !important;
    }

    .tox-tbtn--enabled{
background: transparent !important;
    }
    .btn-wrapper {
      width: max-content;
    }
  }

  .greetings-row {
    .tox-tbtn__select-chevron {
  display: none !important;
}
  }



  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    ${({ $isOfferFlow }) =>
      $isOfferFlow &&
      `
      justify-content: center;
    `}
  }

  ${({ $embedded }) =>
    $embedded &&
    css`
      justify-content: flex-start;

      .content-holder {
        max-width: 100%;
      }

      .embedded-actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 12px;
        margin-top: 10px;
      }

      .aligned-bot-message {
        margin-left: -60px;
      }

      .fields-wrapper > div {
        animation: ${fadeSlideUp} 0.4s ease-out;
      }
    `}
`;
